import type { ReactNode } from 'react';
import { BackButton } from './BackButton';

interface PageHeaderProps {
  title: string;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
  subtitle?: string;
}

/**
 * Consistent page header used throughout MainLayout pages.
 * Renders a back button (if backTo or backLabel is provided),
 * a bold title, optional subtitle, and an optional action area.
 */
export function PageHeader({ title, backTo, backLabel, actions, subtitle }: PageHeaderProps) {
  const showBack = backTo !== undefined || backLabel !== undefined;
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        {showBack && (
          <BackButton to={backTo} label={backLabel ?? 'Back'} className="mb-1" />
        )}
        <h1 className="text-2xl font-bold tracking-tight text-foreground">{title}</h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-3">{actions}</div>}
    </div>
  );
}
